import styled from "styled-components";

/**
 * Header do componente FlightDetails.
 */
export const FlightDetailsTopo = styled.div`
  padding: ${({ theme }) => theme.spacing(0.15)}
    ${({ theme }) => theme.spacing(1)} ${({ theme }) => theme.spacing(4)};
  justify-content: center;
  align-items: center;
  display: flex;

  @media (max-width: ${({ theme }) => theme.breakpoints.sm}) {
    width: 95%;
    align-self: center;
  }
`;

/**
 * Container principal dos detalhes do voo.
 */
export const FlightDetailsContainer = styled.div`
  border: 1px solid ${({ theme }) => theme.colors.darkGray};
  border-radius: ${({ theme }) => theme.borderRadius.large};
  margin: 0 ${({ theme }) => theme.spacing(3)};
  flex-direction: column;
  display: flex;
`;
